const DefaultMarkerColor = '#3FB1CE';
export default DefaultMarkerColor;
